// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1VO04","containerItemsCenter":"Skeleton_containerItemsCenter__2UpSC"};